import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../loader/loader.service';
import { ApiService } from '../service/api.service';
import { AuthService } from '../service/auth.service';
import { DomainManagerService } from '../service/domain-manager.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  ipAddress: any;
  isRadiologyDomain: boolean = false;
  logoUrl: string = '';

  constructor(
    private readonly router: Router,
    private readonly toaster: ToastrService,
    private readonly LoaderService: LoaderService,
    private readonly _http: ApiService,
    private readonly authService: AuthService,
    private readonly domainService: DomainManagerService
  ) { }

  ngOnInit(): void {
    this.isRadiologyDomain = this.domainService.isRadiologyDomain;
    this.logoUrl = this.domainService.getLogoUrl();
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
    }
    this._http.getIPAddress().subscribe((x: any) => {
      const ipAddress = x.ip;
      this.ipAddress = ipAddress;
      localStorage.setItem("IA", this.ipAddress);
    });
  }

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    pass: new FormControl('', [Validators.required, Validators.minLength(6)]),
  });

  get f() {
    return this.form.controls;
  }

  submit() {
    this.LoaderService.show();
    setTimeout(() => {
      let obj: any = {
        Username: this.form.value.email,
        Password: this.form.value.pass,
      };
      this._http.login(obj).subscribe((res: any) => {
        if (res.Success) {
          this.LoaderService.hide();
          localStorage.setItem("AccessToken", res["AccessToken"]);
          localStorage.setItem('loginData', JSON.stringify(res.Data));
          localStorage.setItem('UserName', (res.Data["UserName"]));
          localStorage.setItem('isLogin', JSON.stringify(true));

          this.toaster.success('Logged in Successfully');
          this.router.navigate(['/dashboard']);
        } else if (res.ResponseCode == 411) {
          this.LoaderService.hide();
          localStorage.setItem('isLogin', JSON.stringify(false));

          this.toaster.error(res.Message);
        }
        else {
          this.LoaderService.hide();
          localStorage.setItem('isLogin', JSON.stringify(false));

          this.toaster.error('Invalid Username Password');
        }
      });
      () => {
        this.LoaderService.hide();
        this.router.navigate([""]);
      }
    }, 1000);
  }

  onclickregister() {
    this.router.navigate(['/register']);
  }
}
